export default __webpack_public_path__ + "static/media/trust-unixgaming.2cb17afa.svg";